import HeroImageSimple from './HeroImageSimple'


export default HeroImageSimple
